import React, {Component} from 'react';
import {NavBar, List, Radio, DatePicker,Picker,Badge,Tabs, Toast,InputItem,} from 'antd-mobile';
import {lineList,addShift,driverList,carList,priceModel,runTimeModel,batchShift} from "../../service/shiftService";
import moment from 'moment';
import './style.less';
import {connect} from "react-redux";
import Input from 'antd-mobile/lib/input-item/Input';
// const nowTimeStamp = Date.now();
// const now = new Date(nowTimeStamp);
const now = new Date();
// let lineIdc = [];
const tabs = [
  { title: <Badge>添加手动行程</Badge> },
  { title: <Badge>添加批量行程</Badge> },
];
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class AddShift extends Component {
    constructor(props) {
        super(props);
        this.state = {
            carModal:false,
            priceModal:false,
            runTimeModal:false,
            date:now,
            lineClass:'',
            lineDriver:'',
            lineCar:'',
            lineId:'',//用于请求价格模板和运行时间模板的数据
            driverId:'',//用于请求车辆的数据
            carId:'',//用于提交行程
            priceTemplateId:'',//用于提交行程
            runTimeTemplateId:'',//用于提交行程
            radioData: [
                {value: 1, label: '是'},
                {value: 0, label: '否'},
            ],
            radioData2: [
              {value: 0, label: '否'},
              {value: 1, label: '是'},
            ],
            radioData3: [
              {value: 0, label: '否'},
              {value: 1, label: '是'},
            ],
            classVal:1,
            classVal2:0,
            classVal3:0,
            priceModel:'',
            runTime:'',
            startTime:'',
            driverData:[],
            lineData:[],
            carNumData:[],
            priceData:[],
            runTimeData:[],
            dispatcherId:[],
            seatNum:'',
            tabsStatus:'manual',
            batchStartTime:'',
            batchEndTime:'',
            minute:'',
            oneMostDay:'',
            mostDay:'',
            startDay:'',
            endDay:'',
            dateVisible:false,
        };

        this._onCheckChanges = this._onCheckChanges.bind(this);
        this.noData = this.noData.bind(this);
    }
    componentDidMount() {
      // lineIdc = []
      this.getLineData();
      this.getDriverData();
    }
    //获取起止区域数据
    getLineData(){
      let params = {
          token: this.props.userInfo.token,
          "data": {
              "dispatcherId": this.props.userInfo.userId
          }
          
      };
      lineList(params)
          .then((res) => {
              if (res.data.code === '0000') {
                let lineData = []
                let data = res.data.data
                for(let i in data){
                  let temp = data[i];
                  lineData.push({
                    label:temp.name,
                    value:temp.name,
                    id:temp.id
                  })
                }
                this.setState({
                  lineData:lineData,
                  oneMostDay:data[0].oneMostDay,
                  mostDay:data[0].mostDay,
                })
              }
              else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
              }
              else {
                  Toast.info(res.data.msg);
              }
          }).catch(function (error) {
          console.log(error);
      });
    };
    //获取司机数据
    getDriverData(){
      let params = {
          token: this.props.userInfo.token,
          "data": {
              "dispatcherId": this.props.userInfo.userId,
              "businessType":1,
          }
      };
      driverList(params)
          .then((res) => {
              if (res.data.code === '0000') {
                let driverData = []
                let data = res.data.data
                for(let i in data){
                  let temp = data[i];
                  driverData.push({
                    label:temp.name,
                    value:temp.name,
                    id:temp.id
                  })
                }
                this.setState({
                  driverData:driverData,
                })
              }
              else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
              }
              else {
                  Toast.info(res.data.msg);
              }
          }).catch(function (error) {
          console.log(error);
      });
    };

    /**
     * 
     */
    _onCheckChanges(key) {
      if (this.state.lineClass != '') {
        setTimeout(() => {
          this.getRunTimeData();
        }, 0);
      }

      switch (key) {
        case 'priceModel'://选择价格模板时，检查数据
          this.noData('price');
          if (this.state.lineClass != '' && this.state.lineDriver != '' && this.state.lineCar != '') {
            setTimeout(() => {
              this.getPriceModelData();

            }, 0);
          }

      }
    }

    addActive(v, key){
        if(key == 'lineClass'){
            let datas = this.state.lineData;
            let labels = [];
            datas.forEach(e =>{
              labels.push(e.label)
            })
      
            this.setState({
                    [key]:v,
                    lineId:datas[labels.indexOf(v[0])].id,
                    lineDriver:"",
                    lineCar:"",
                    runTime:"",
                    priceModel:"",
                  });
            // setTimeout(() => {            
            //   this.getRunTimeData();
            // }, 0);
          };
            
        if(key == 'lineDriver'){
          let datas = this.state.driverData;
          let labels = [];
          datas.forEach(e =>{
            labels.push(e.label)
          })
          this.setState({
                  [key]:v,
                  driverId:datas[labels.indexOf(v[0])].id
          });
          setTimeout(() => {
            this.getCarData();
          }, 1000);
        
        };
        if(key == 'lineCar'){
          let datas = this.state.carNumData;
          let labels = [];
          datas.forEach(e =>{
            labels.push(e.label)
          })
          this.setState({
            [key]:v,
            carId:datas[labels.indexOf(v[0])].id,
            seatNum:datas[labels.indexOf(v[0])].seatNum,
            carModal:false,
          });
        }
        if(key == 'priceModel'){
          let datas = this.state.priceData;
          let labels = [];
          datas.forEach(e =>{
            labels.push(e.label)
          })
          this.setState({
            [key]:v,
            priceTemplateId:datas[labels.indexOf(v[0])].id,
            priceModal:false,
          });
        }
        if(key == 'runTime'){
          let datas = this.state.runTimeData;
          let labels = [];
          datas.forEach(e =>{
            labels.push(e.label)
          })
          this.setState({
            [key]:v,
            runTimeTemplateId:datas[labels.indexOf(v[0])].id,
            runTimeModal:false
          });
        }
        console.log(moment(this.state.startDay).format('YYYY年MM月DD日'))
        console.log(moment(v).format('YYYY年MM月DD日'))
        console.log(moment(this.state.startDay).add(parseInt(this.state.oneMostDay),'day').format('YYYY年MM月DD日'))
        if(key == 'endDay'){
          if(moment(v).format('YYYY年MM月DD日') > moment(this.state.startDay).add(parseInt(this.state.oneMostDay),'day').format('YYYY年MM月DD日')){
            Toast.info("最大一次可批量排班天数为"+this.state.oneMostDay+"天,请重新选择时间")
          }else{
            this.setState({
              [key]:v,dateVisible:false
            });
          }
        }
        if(key == "startTime" || key == 'batchStartTime' || key == 'batchEndTime'|| key == 'startDay'){
          this.setState({
            [key]:v,
          });
        }

    }
    //获取车辆数据
    getCarData(){
      let params = {
          token: this.props.userInfo.token,
          "data":{
            "driverId":this.state.driverId,
            "businessType":"1",
            "dispatcherId": this.props.userInfo.userId,
        }
      };
      carList(params)
          .then((res) => {
              if (res.data.code === '0000') {
                let carData = []
                let data = res.data.data
                for(let i in data){
                  let temp = data[i];
                  carData.push({
                    label:temp.carNum,
                    value:temp.carNum,
                    id:temp.id,
                    seatNum:temp.seatNum
                  })
                }
                this.setState({
                  carNumData:carData
                })
              }
              else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
              }
              else {
                  Toast.info(res.data.msg);
              }
          }).catch(function (error) {
          console.log(error);
      });
    };
    //获取价格模板数据
    getPriceModelData(){
      let params = {
          token: this.props.userInfo.token,
          "data":{
            "lineId":this.state.lineId,
            "seatNum":this.state.seatNum
          }
      };
      console.log(params)
      priceModel(params)
          .then((res) => {
              if (res.data.code === '0000') {
                let priceData = []
                let data = res.data.data
                for(let i in data){
                  let temp = data[i];
                  priceData.push({
                    label:temp.name,
                    value:temp.name,
                    id:temp.id
                  })
                }
                this.setState({
                  priceData:priceData
                })
                // lineIdc = priceData
              }
              else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
              }
              else {
                  Toast.info(res.data.msg);
              }
          }).catch(function (error) {
          console.log(error);
      });
    };
    //获取运行时间模板数据
    getRunTimeData(){
      let params = {
          token: this.props.userInfo.token,
          "data":{
            "lineId":this.state.lineId
          }
      };
      runTimeModel(params)
          .then((res) => {
              if (res.data.code === '0000') {
                let runTimeData = []
                let data = res.data.data
                for(let i in data){
                  let temp = data[i];
                  runTimeData.push({
                    label:temp.name,
                    value:temp.name,
                    id:temp.id
                  })
                }
                this.setState({
                  runTimeData:runTimeData
                })
              }
              else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
              }
              else {
                  Toast.info(res.data.msg);
              }
          }).catch(function (error) {
          console.log(error);
      });
    };
    // 新增运力
    ok = () => {
      if(this.state.tabsStatus === 'manual'){
        let params = {
          token: this.props.userInfo.token,
          "data":{
            "dispatcherId":this.props.userInfo.userId,
            "name":this.state.lineClass[0],
            "lineId":this.state.lineId,
            "driverId":this.state.driverId,
            "carId":this.state.carId,
            "priceTemplateId":this.state.priceTemplateId,
            "runTimeTemplateId":this.state.runTimeTemplateId,
            "departureDate":moment(this.state.startTime).format('YYYY-MM-DD HH:mm:ss'),
            "isAvailable":this.state.classVal,
            "isAddWork":this.state.classVal2,
            "isBusiness":this.state.classVal3,
          }
        };
        Toast.loading("正在加载",0);
        addShift(params)
            .then((res) => {
                if (res.data.code === '0000') {
                  Toast.hide();
                  Toast.info('添加行程成功');
                  setTimeout(() => {
                   this.props.history.goBack();
                  }, 1000);
                } else {
                    Toast.info(res.data.msg);
                }
            }).catch(function (error) {
            console.log(error);
        });
      }else{
        let params = {
          token: this.props.userInfo.token,
          "data":{
            "dispatcherId":this.props.userInfo.userId,
            "name":this.state.lineClass[0],
            "lineId":this.state.lineId,
            "driverId":this.state.driverId,
            "carId":this.state.carId,
            "priceTemplateId":this.state.priceTemplateId,
            "runTimeTemplateId":this.state.runTimeTemplateId,
            // "departureDate":moment(this.state.startTime).format('YYYY-MM-DD'),
            "startDay":moment(this.state.startDay).format('YYYY-MM-DD'),
            "endDay":moment(this.state.endDay).format('YYYY-MM-DD'),
            "isAvailable":1,
            "startDate":moment(this.state.batchStartTime).format('HH:mm:ss'),
            "endDate":moment(this.state.batchEndTime).format('HH:mm:ss'),
            "intervalDate":this.state.minute
          }
        };
        console.log(params)
        Toast.loading("正在加载",0);
        batchShift(params)
            .then((res) => {
                if (res.data.code === '0000') {
                  Toast.hide();
                  Toast.info('批量添加行程成功');
                  setTimeout(() => {
                   this.props.history.goBack();
                  }, 1000);
                } else {
                    Toast.info(res.data.msg);
                }
            }).catch(function (error) {
            console.log(error);
        });
      }
     
    };
    onChange = (val) => {
        this.setState({ val });
        
    }
    // noData=(k)=>{
    noData(k){
      if(k == 'endDay'){
        if(!this.state.startDay){
          Toast.info('请先选择开始日期')
        }else{
          this.setState({dateVisible:true})
        }
      }
      //起止区域根据调度人员获取，司机也根据调度人员获取，车辆根据司机获取，价格模板根据车辆返回的出行位置数和起止区域，运行时间根据起止区域获取
      if(k == 'car'){
        if(this.state.lineDriver == ''){
          Toast.info('请先选择司机')
        }else{
          this.setState({
            carModal:true
          })
        }
      }
      //价格模板
      if(k == 'price'){
        if(this.state.lineClass == ''|| this.state.lineDriver == ''||this.state.lineCar == ''){
          Toast.info('请按照先后顺序选择起止区域，司机和车辆！')
        }
        else{
              this.setState({
                priceModal:true
              })
        }
      }
      //运行时间模板
      if(k == 'runTime'){
        if(this.state.lineClass == ''){
          Toast.info('请先选择起止区域')
        }else{
          this.setState({
            runTimeModal:true
          })
        }
      }
     
    }
    pushParam=(tab,index)=>{
      this.setState({
          tabsStatus:index == 0 ? 'manual' : 'automatic' 
      })
    }  
    Change = key =>(e) =>{
      this.setState({ [key]: e })
    };
    render() {
        return (
            <div className="addShiftScreen">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}></i>}
                >添加行程</NavBar>
                <Tabs 
                    // tabBarActiveTextColor={'#1D1E2C'}
                    // tabBarInactiveTextColor={'#69707F'} 
                    // tabBarUnderlineStyle={{backgroundColor:'#FF8E1D',border:'1px #FF8E1D solid'}}
                    tabs={tabs}
                    initialPage={0}
                    // onChange={(tab, index) => { this.setState({type:index + 1}) }}
                    onTabClick={(tab, index) => {this.pushParam(tab,index)}}
                >
                {
                  this.state.tabsStatus == 'manual' ?
                    <List className="address">
                      <Picker
                          cols={1}
                          extra={'请选择起止区域'}
                          data={this.state.lineData}
                          value={this.state.lineClass}
                          onOk={(v) =>this.addActive(v, 'lineClass')}
                      >
                          <List.Item arrow="horizontal">起止区域</List.Item>
                      </Picker>
                      <Picker
                          cols={1}
                          extra={'请选择司机'}
                          data={this.state.driverData}
                          value={this.state.lineDriver}
                          onOk={(v) =>this.addActive(v, 'lineDriver')}
                  >
                      <List.Item arrow="horizontal">司机</List.Item>
                  </Picker>
                      <Picker
                          cols={1}
                          extra={'请选择车辆'}
                          visible={this.state.carModal}
                          data={this.state.carNumData}
                          onDismiss={()=>this.setState({carModal:false})}
                          value={this.state.lineCar}
                          onOk={(v) =>this.addActive(v, 'lineCar')}
                      >
                          <List.Item arrow="horizontal" onClick={()=>this.noData('car')}>车辆</List.Item>
                      </Picker>
                      <Picker
                          cols={1}
                          extra={'请选择价格模板'}
                          visible={this.state.priceModal}
                          data={this.state.priceData}
                          onDismiss={()=>this.setState({priceModal:false})}
                          value={this.state.priceModel}
                          onOk={(v) =>this.addActive(v, 'priceModel')}
                      >
                          <List.Item arrow="horizontal" onClick={()=>{this._onCheckChanges('priceModel')}}>价格模板</List.Item>
                      </Picker>
                      <Picker
                          cols={1}
                          extra={'请选择运行时间模板'}
                          visible={this.state.runTimeModal}
                          onDismiss={()=>this.setState({runTimeModal:false})}
                          data={this.state.runTimeData}
                          value={this.state.runTime}
                          onOk={(v) =>this.addActive(v, 'runTime')}
                      >
                          <List.Item arrow="horizontal" onClick={()=>this.noData('runTime')}>运行时间</List.Item>
                      </Picker>
                      <DatePicker
                          value={this.state.startTime}
                          extra={'请选择行程日期'}
                          onOk={(v) =>this.addActive(v, 'startTime')}
                          defaultDate={new Date()}
                          minDate={new Date()}
                          maxDate={new Date(+now + 5184000000)}
                          onChange={(v)=>this.setState({startTime:v})}
                      >
                          <List.Item arrow="horizontal">日期</List.Item>
                      </DatePicker>
                      <List.Item>
                          是否开放下单
                          {this.state.radioData.map((res, i) => (
                              <Radio className="my-radio" key={i} checked={this.state.classVal === res.value}
                                  onChange={() => this.setState({classVal: res.value})}>
                                  {res.label}
                              </Radio>
                          ))}
                      </List.Item>
                      <List.Item>
                          是否加班车
                          {this.state.radioData2.map((res, i) => (
                              <Radio className="my-radio" key={i} checked={this.state.classVal2 === res.value}
                                  onChange={() => this.setState({classVal2: res.value})}>
                                  {res.label}
                              </Radio>
                          ))}
                      </List.Item>
                      <List.Item>
                          是否商务车
                          {this.state.radioData3.map((res, i) => (
                              <Radio className="my-radio" key={i} checked={this.state.classVal3 === res.value}
                                  onChange={() => this.setState({classVal3: res.value})}>
                                  {res.label}
                              </Radio>
                          ))}
                      </List.Item>
                  </List> 
                  :
                  <List className="address">
                  <Picker
                      cols={1}
                      extra={'请选择起止区域'}
                      data={this.state.lineData}
                      value={this.state.lineClass}
                      onOk={(v) =>this.addActive(v, 'lineClass')}
                  >
                      <List.Item arrow="horizontal">起止区域</List.Item>
                  </Picker>
                  <Picker
                      cols={1}
                      extra={'请选择司机'}
                      data={this.state.driverData}
                      value={this.state.lineDriver}
                      onOk={(v) =>this.addActive(v, 'lineDriver')}
              >
                  <List.Item arrow="horizontal">司机</List.Item>
              </Picker>
                    <Picker
                        cols={1}
                        extra={'请选择车辆'}
                        visible={this.state.carModal}
                        data={this.state.carNumData}
                        onDismiss={()=>this.setState({carModal:false})}
                        value={this.state.lineCar}
                        onOk={(v) =>this.addActive(v, 'lineCar')}
                    >
                        <List.Item arrow="horizontal" onClick={()=>this.noData('car')}>车辆</List.Item>
                    </Picker>
                    <Picker
                        cols={1}
                        extra={'请选择价格模板'}
                        visible={this.state.priceModal}
                        data={this.state.priceData}
                        onDismiss={()=>this.setState({priceModal:false})}
                        value={this.state.priceModel}
                        onOk={(v) =>this.addActive(v, 'priceModel')}
                    >
                        <List.Item arrow="horizontal" onClick={()=>{this._onCheckChanges('priceModel')}}>价格模板</List.Item>
                    </Picker>
                    <Picker
                        cols={1}
                        extra={'请选择运行时间模板'}
                        visible={this.state.runTimeModal}
                        onDismiss={()=>this.setState({runTimeModal:false})}
                        data={this.state.runTimeData}
                        value={this.state.runTime}
                        onOk={(v) =>this.addActive(v, 'runTime')}
                    >
                        <List.Item arrow="horizontal" onClick={()=>this.noData('runTime')}>运行时间</List.Item>
                    </Picker>
                    <DatePicker
                        mode="date"
                        value={this.state.startDay}
                        extra={'请选择行程开始日期'}
                        onOk={(v) =>this.addActive(v, 'startDay')}
                        // defaultDate={new Date()}
                        minDate={new Date(+now + 86400000)}
                        maxDate={new Date(+now + parseInt(this.state.mostDay))}
                        // onChange={(v)=>this.setState({startDay:v})}
                    >
                        <List.Item arrow="horizontal">开始日期</List.Item>
                    </DatePicker>
                    <DatePicker
                        mode="date"
                        value={this.state.endDay}
                        visible={this.state.dateVisible}
                        onDismiss={() => {this.setState({dateVisible:false})}}
                        extra={'请选择行程结束日期'}
                        onOk={(v) =>this.addActive(v, 'endDay')}
                        // defaultDate={new Date()}
                        minDate={new Date(+now + 86400000)}
                        maxDate={new Date(+now + parseInt(this.state.mostDay))}
                        // onChange={(v)=>this.setState({endDay:v})}
                    >
                        <List.Item arrow="horizontal" onClick={()=>this.noData('endDay')}>结束日期</List.Item>
                    </DatePicker>
                  <DatePicker
                      mode="time"
                      value={this.state.batchStartTime}
                      extra={'请选择批量行程开始时间'}
                      onOk={(v) =>this.addActive(v, 'batchStartTime')}
                      // minuteStep={2}
                      // use12Hours
                      // defaultDate={new Date()}
                      // minDate={new Date()}
                      // maxDate={new Date(+now + 5184000000)}
                      onChange={(v)=>this.setState({batchStartTime:v})}
                  >
                      <List.Item arrow="horizontal">开始时间</List.Item>
                  </DatePicker>
                  <DatePicker
                    mode="time"
                    value={this.state.batchEndTime}
                    extra={'请选择批量行程结束时间'}
                    // minuteStep={2}
                    // use12Hours
                    // minDate={new Date()}
                    // maxDate={new Date(+now + 5184000000)}
                    onOk={(v) =>this.addActive(v, 'batchEndTime')}
                    defaultDate={new Date()}
                    onChange={(v)=>this.setState({batchEndTime:v})}
                >
                    <List.Item arrow="horizontal">结束时间</List.Item>
                </DatePicker>
                    <InputItem
                    className="font28"
                    placeholder="请输入间隔分钟"
                    value={this.state.minute}
                    onChange={(v)=>this.setState({minute:v})}
                    style={{textAlign:'left'}}
                    type="number"
                ><span className="font28">行程间隔</span></InputItem> 
              </List>


                }
                      
              </Tabs>
                <button className="addBtn" onClick={this.ok}>保存</button>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/AddShift/index.js